/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateDistrictCommand } from '../../models/update-district-command';
import { UpdateDistrictCommandResult } from '../../models/update-district-command-result';

export interface ApiDistrictUpdateDistrictPatch$Plain$Params {
      body?: UpdateDistrictCommand
}

export function apiDistrictUpdateDistrictPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiDistrictUpdateDistrictPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateDistrictCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiDistrictUpdateDistrictPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateDistrictCommandResult>;
    })
  );
}

apiDistrictUpdateDistrictPatch$Plain.PATH = '/api/District/UpdateDistrict';
